import React from 'react'

import ChildrenRepliesSection from './replies/ChildrenRepliesSection'
import Overview from './general/Overview'
import Page from '../../../components/pdf/Page'
import RepliesSection from './replies/RepliesSection'
import ServiceOrderHeader from './general/ServiceOrderHeader'
import DocumentHeader from './general/documentHeader/DocumentHeader'
import { usePdfOptionsForm } from '../../../components/pdf/options/_form/PdfOptionsFormHandler'

const PdfDocument = ({ serviceOrder, categories, counters, childrenServiceOrders }) => {
  const form = usePdfOptionsForm()
  return (
    <Page>
      <DocumentHeader />
      <ServiceOrderHeader serviceOrder={serviceOrder} counters={counters} />
      <Overview serviceOrder={serviceOrder} />
      <RepliesSection serviceOrder={serviceOrder} categories={categories} />
      {!form.hideChildrenServiceOrders &&
        childrenServiceOrders.map(serviceOrder => (
          <ChildrenRepliesSection key={serviceOrder.id} serviceOrder={serviceOrder} />
        ))}
    </Page>
  )
}

export default PdfDocument
